export default __webpack_public_path__ + "static/media/ReportingConnecsIcon.0c597dae.svg";